/*去除左右空格*/
export const trim = (s: any) => {
  return s.replace(/(^\s*)|(\s*$)/g, "");
};

/*时间转换*/
export const dateFormat = (date: any) => {
  if (date) {
    const dateTime = new Date(date);
    const Y = dateTime.getFullYear() + "-";
    const M =
      (dateTime.getMonth() + 1 < 10
        ? "0" + (dateTime.getMonth() + 1)
        : dateTime.getMonth() + 1) + "-";
    const D =
      (dateTime.getDate() < 10
        ? "0" + dateTime.getDate()
        : dateTime.getDate()) + " ";
    const h =
      (dateTime.getHours() < 10
        ? "0" + dateTime.getHours()
        : dateTime.getHours()) + ":";
    const m =
      (dateTime.getMinutes() < 10
        ? "0" + dateTime.getMinutes()
        : dateTime.getMinutes()) + ":";
    const s =
      dateTime.getSeconds() < 10
        ? "0" + dateTime.getSeconds()
        : dateTime.getSeconds();
    return Y + M + D + h + m + s;
  }
  return "";
};

/*生成随机字符串*/
export const getRandomString = (capacity: number) => {
  const chars = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
  let res = "";
  for (let i = 0; i < capacity; i++) {
    const id = Math.ceil(Math.random() * chars.length);
    res += chars[id];
  }
  return res;
};
